'use client';

import ButtonLink from '@/components/general/ButtonLink';
import { Box, Flex, Heading, Section, Text } from '@radix-ui/themes';
import { useTranslations } from 'next-intl';
import NextImage from 'next/image';

const sections = [
  {
    section: 'OurVision',
    title: `Our Vision`,
    description: `The Chesed Club is an extension of Mada Centre's mission, tailored for the digital world of children. Our
              platform reflects Mada's dedication to kindness and support, nurturing these values in young,
              impressionable minds.`,
    image:
      'https://assets-global.website-files.com/63b371ba462a084a8b16493c/64d4031f1c6ebcca42e9d9f0_yellow_64d3e5dfaf1c397b3b9f654b_10733741_10152667050586655_698061880806162100_o.jpeg',
    width: 1500,
    height: 1125,
  },
  {
    section: 'ValuesInAction',
    title: `Values in Action`,
    description: `Rooted in Mada's core value of Chesed (love and kindness), every aspect of The Chesed Club is designed to instill these principles in children. Our activities and stories are carefully crafted to echo Mada’s ethos of unconditional kindness and community support.`,
    image:
      'https://assets-global.website-files.com/63b371ba462a084a8b16493c/64d4031e1c6ebcca42e9d8a1_red_64d3e82ee9b27088a522b4a3_57131091_10157083673191655_4355561308792291328_n.jpeg',
    width: 2048,
    height: 1152,
  },
  {
    section: 'LegacyFuture',
    title: `Legacy for the Future`,
    description: `As part of the Mada family, The Chesed Club is not just an app—it's a commitment to raising a generation
                that values empathy and understands the power of giving, carrying forward Mada's legacy of positive
                impact.
`,
    image: 'https://assets-global.website-files.com/63b371ba462a084a8b16493c/63d44048717387fdfd8589e7_Mada4.jpeg',
    width: 960,
    height: 640,
  },
];

type CausesPagesProps = {
  params: Promise<{ locale: string }>;
};

export default function CausesPage({ params }: CausesPagesProps) {
  const t = useTranslations();
  return (
    <Flex direction="column" align="center" px="4">
      <Section>
        <Heading align="center" size="7">
          About Us
        </Heading>
        <Flex align="center" py="4">
          <Flex direction="column" justify="center" px="4" py="4">
            <Flex justify="center" align="center">
              <NextImage
                src="https://assets-global.website-files.com/63b371ba462a084a8b16493c/63d4404cec66f8ddf81301a4_Mada6.jpeg"
                alt=""
                className="object-cover w-full  border-black border-3 h-80"
                width={2700}
                height={1368}
              />
            </Flex>
            <Box mb="6">
              <Heading>{t('AboutUs.header')}</Heading>
              <Text>{t('AboutUs.headerDescription')}</Text>
            </Box>
            {sections.map((section, id) => (
              <Box key={id} mb="6">
                <Box>
                  <NextImage
                    src={section.image}
                    alt=""
                    className="flex-inline object-cover border-black border-3 h-56 md:h-80"
                    width={section.width}
                    height={section.height}
                  />
                </Box>
                <Box>
                  <Heading>{t(`AboutUs.${section.section}.title`)}</Heading>
                  <Text>{t(`AboutUs.${section.section}.description`)}</Text>
                </Box>
              </Box>
            ))}
          </Flex>
        </Flex>
        <Flex align="center" justify="center">
          <ButtonLink text={t('AboutUs.ContactUs')} href={'mailto:info@chesed.club'} variant={'solid'} size={'3'} />
        </Flex>
      </Section>
    </Flex>
  );
}
